export default "/assets/images/nerd-face.c6d9b87185cdd8af.png";